// Tras un despliegue, una pestaña abierta con la versión anterior pide chunks
// (AdminDashboard-xxxx.js…) que ya no existen → "Failed to fetch dynamically
// imported module". Se recarga UNA vez para coger el build nuevo; el flag en
// sessionStorage evita bucles si el fallo es de red de verdad.
export const STALE_CHUNK_FLAG = '_mc_stale_chunk_reload';

const STALE_RE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

export function isStaleChunkError(err) {
  return STALE_RE.test(String(err?.message || err || ''));
}

// Devuelve true si ha lanzado la recarga (el llamador puede mostrar "Actualizando…").
export function reloadForStaleChunk() {
  try {
    if (sessionStorage.getItem(STALE_CHUNK_FLAG)) return false;
    sessionStorage.setItem(STALE_CHUNK_FLAG, String(Date.now()));
  } catch (_) { /* sin sessionStorage: recargamos igualmente una vez */ }
  console.warn('[stale chunk] Recargando para obtener la versión nueva…');
  if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
  if ('caches' in window) caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
  setTimeout(() => window.location.reload(), 300);
  return true;
}
